<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title class="ion-text-center" *ngIf="item && item.title">
            {{item.title}}
            <p *ngIf="item.subtitle" class="subtitle">{{item.subtitle}}</p>
        </ion-title>
        <ion-buttons *ngIf="item && cart && item.sell_price !== null && item.quantity !== null && item.discount_amount !== null" slot="end">
            <ion-button  (click)="confirmationClicked()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <ion-segment color="primary" [(ngModel)]="segment">
        <ion-segment-button value="pricing" checked>
            <ion-label>Pricing</ion-label>
        </ion-segment-button>
        <ion-segment-button value="notes">
            <ion-label>Notes</ion-label>
        </ion-segment-button>
    </ion-segment>

</ion-header>

<ion-content *ngIf="item && cart" [ngClass]="{'on-device': on_device == true, 'not-on-device': on_device == false}">

    <ng-container [ngSwitch]="segment">

        <ng-container *ngSwitchCase="'pricing'">

            <ion-grid class="ion-no-padding pricing">

                <ion-row>
                    <ion-col>
                        <ion-grid class="ion-no-padding inputs">
                            <ion-row class="ion-align-items-center ion-justify-content-center">
                                <ion-col size="8">
                                    Price 
                                    <ng-container *ngIf="item.has_custom_price"> (custom)</ng-container>
                                    <ng-container *ngIf="item.has_contract_price"> (contract)</ng-container>
                                    <ng-container *ngIf="item.has_volume_discount"> (volume discount)</ng-container>
                                    <span *ngIf="item.comparison_price_percentage_difference > 0" class="negative" style="font-size: 14px; display:block; ">({{item.comparison_price_percentage_difference | number:'1.2'}}% off {{cart.currency.sign}}{{item.comparison_price | number:'1.2'}} comparison price)</span>
                                </ion-col>
                                <ion-col size="4" class="input">
                                    <span>{{cart.currency.sign}}</span>
                                    <ion-input type="tel" inputmode="decimal" maxlength="10" label="" aria-label="Price" [(ngModel)]="item_sell_price" (ngModelChange)="sanitiseItemSellPrice()"></ion-input>
                                </ion-col>
                            </ion-row>
                            <ion-row *ngIf="is_donation_or_voucher == false" class="ion-align-items-center">
                                <ion-col size="8">Quantity<ng-container *ngIf="item.measurement_unit"> ({{item.measurement_unit.symbol}})</ng-container></ion-col>
                                <ion-col size="4" class="input quantity">
                                    <fa-icon [icon]="['fas', 'minus']" (click)="adjustItemQuantity('subtract')"></fa-icon>
                                    <ion-input type="tel" inputmode="decimal" maxlength="10" class="ion-text-center" label="" aria-label="Quantity" [(ngModel)]="item_quantity" (ngModelChange)="sanitiseItemQuantity()"></ion-input>
                                    <fa-icon [icon]="['fas', 'plus']" (click)="adjustItemQuantity('add')"></fa-icon>
                                </ion-col>
                            </ion-row>
                            <ion-row *ngIf="is_donation_or_voucher == false" class="ion-align-items-center">
                                <ion-col size="8">Discount</ion-col>
                                <ion-col size="4" class="input discount">
                                    <span [ngClass]="{'selected': item.discount_type == 'fixed_amount'}" (click)="adjustItemDiscountType('fixed_amount')">{{cart.currency.sign}}</span>
                                    <span [ngClass]="{'selected': item.discount_type == 'percentage'}" (click)="adjustItemDiscountType('percentage')">%</span>
                                    <ion-input type="tel" inputmode="decimal" maxlength="10" label="" aria-label="Discount" [(ngModel)]="item_discount_amount" (ngModelChange)="sanitiseItemDiscountAmount()"></ion-input>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-col>
                </ion-row>
                <ng-container *ngIf="item.sell_price !== null && item.quantity !== null && item.discount_amount !== null && item.quantity > 0">
                    <ion-row>
                        <ion-col>
                            <table class="datatable compact">
                                <tr>
                                    <td class="border-top">Subtotal</td>
                                    <td class="border-top ion-text-right ion-text-nowrap">{{item.quantity}} x {{cart.currency.sign}}{{item.sell_price | number:'1.2'}} = {{cart.currency.sign}}{{item.sell_subtotal_amount | number:'1.2'}}</td>
                                </tr>
                                <tr>
                                    <td>Discount</td>
                                    <td class="ion-text-right ion-text-nowrap">
                                        <ng-container *ngIf="item.discount_price > 0"><ng-container *ngIf="item.discount_type == 'percentage'">{{item.discount_amount}}% off = </ng-container>–</ng-container>{{cart.currency.sign}}{{item.discount_price | number:'1.2'}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="double-border">TOTAL</td>
                                    <td class="ion-text-right ion-text-nowrap double-border">{{cart.currency.sign}}{{item.total_price | number:'1.2'}}</td>
                                </tr>
                                <ng-container *ngIf="item.cost_price && auto_hide_price_breakdown == false">
                                    <tr>
                                        <td>Total cost</td>
                                        <td class="ion-text-right ion-text-nowrap">{{item.quantity}} x –{{cart.currency.sign}}{{item.cost_price | number:'1.2'}} = –{{cart.currency.sign}}{{item.cost_subtotal_amount | number:'1.2'}}</td>
                                    </tr>
                                    <tr>
                                        <td>Inclusive tax</td>
                                        <td class="ion-text-right ion-text-nowrap">–{{cart.currency.sign}}{{item.tax_price | number:'1.2'}}</td>
                                    </tr>
                                    <tr>
                                        <td class="double-border">PROFIT</td>
                                        <td class="ion-text-right ion-text-nowrap double-border">
                                            <span class="negative" *ngIf="item.profit <= 0">–{{cart.currency.sign}}{{item.profit | number:'1.2' | replace: '-' : ''}}</span>
                                            <span class="positive" *ngIf="item.profit > 0">{{cart.currency.sign}}{{item.profit | number:'1.2' }}</span>                                        
                                        </td>
                                    </tr>
                                    <tr *ngIf="item_sell_price > 0">
                                        <td>MARGIN</td>
                                        <td class="ion-text-right ion-text-nowrap">
                                            <span class="negative" *ngIf="item.margin == 0">{{item.margin | number:'1.2'}}%</span>
                                            <span class="negative" *ngIf="item.margin < 0">–{{item.margin | number:'1.2' | replace: '-' : ''}}%</span>
                                            <span class="positive" *ngIf="item.margin > 0">{{item.margin | number:'1.2'}}%</span>
                                        </td>
                                    </tr>
                                </ng-container>
                            </table>
                        </ion-col>
                    </ion-row>
                    <ion-row class = "price-breakdown-toggle" *ngIf="auto_hide_price_breakdown == true" (click)="togglePriceBreakdown()">
                        <ion-col>
                            <fa-icon [icon]="['far', 'eye']" size="med" [fixedWidth]="true"></fa-icon>Show price breakdown
                        </ion-col>
                    </ion-row>
                    <ion-row class = "price-breakdown-toggle" *ngIf="auto_hide_price_breakdown == false" (click)="togglePriceBreakdown()">
                        <ion-col>
                            <fa-icon [icon]="['far', 'eye-slash']" size="med" [fixedWidth]="true"></fa-icon>Hide price breakdown
                        </ion-col>
                    </ion-row>
                </ng-container>

            </ion-grid>

        </ng-container>

        <ng-container *ngSwitchCase="'notes'">

            <ion-grid class="form">
                <ion-row>
                    <ion-col>
        
                        <ion-grid class="fieldset">
                            <ion-row>
                                <ion-col>
                                    <ion-textarea #customer_note_input type="text" inputmode="text" [autoGrow]="true" maxlength="1000" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="item.customer_note">
                                        <div slot="label">Note for customer<ion-text class="optional">optional</ion-text></div>
                                    </ion-textarea>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <ion-textarea type="text" inputmode="text" [autoGrow]="true" maxlength="1000" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="item.internal_note">
                                        <div slot="label">Internal note<ion-text class="optional">optional</ion-text></div>
                                    </ion-textarea>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
        
                    </ion-col>
                </ion-row>
            </ion-grid>

        </ng-container>

    </ng-container>

</ion-content>
